export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";